export enum EntityStateEnum {
  CREATING = 'CREATING',
  EXISTS = 'EXISTS',
}
